import script from "./StatusHome.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusHome.vue?vue&type=script&setup=true&lang=js"

import "./StatusHome.vue?vue&type=style&index=0&id=3651e960&lang=css"
import "./StatusHome.vue?vue&type=style&index=1&id=3651e960&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3651e960"]])

export default __exports__